import axios from 'axios';

const API_URL = '/api/search/';

class SearchService {
  // Search public content
  searchPublicContent(query, page = 0, size = 10) {
    return axios.get(API_URL + 'public', {
      params: { q: query, page, size }
    });
  }

  // Get search suggestions
  getSuggestions(query, limit = 5) {
    return axios.get(API_URL + 'suggestions', {
      params: { q: query, limit }
    });
  }
}

export default new SearchService();